// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + __webpack_require__.h() + "-1738737203146.chunk.js";
};